import React, { Component } from 'react';
import ServiceTable from './ServiceTable';

class Services extends Component {
  render() {
    return (
      <div className="content">
        <ServiceTable />
      </div>
    );
  }
}

export default Services;
